import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {EuKpiComponent} from "../page/eu-overview-page/components/kpiComponent/eu-kpi.component";
import {EuStatisticsComponent} from "../page/eu-overview-page/components/statisticsComponent/eu-statistics.component";
import {EuAppConfigPage} from "../page/overview/eu-app-config/eu-app-config.page";
import {EuConfigComponent} from "../page/overview/eu-config-page/eu-config.component";
import {EuConfigPageWebappComponent} from "../page/overview/eu-config-page-webapp/eu-config-page-webapp.component";
import {EuOverviewPage} from "../page/overview/eu-overview/eu-overview.page";
import {EuRegistrationOverviewPage} from "../page/overview/eu-registration-overview/eu-registration-overview.page";

const euModuleEntry: TestModuleDefinition = {
    key: 'eu',
    label: 'EndUser (eu)',
    components: [

        {
            key: 'EuKpiComponent',
            component: EuKpiComponent,
            selector: 'eu-kpi',
            type: 'Component',
            label: 'EU KPI',
        },
        {
            key: 'EuStatisticsComponent',
            component: EuStatisticsComponent,
            selector: 'eu-statistics',
            type: 'Component',
            label: 'EU Statistics',
        },
        {
            key: 'EuAppConfigPage',
            component: EuAppConfigPage,
            selector: 'mvs-eu-app-config',
            type: 'PageComponent',
            label: 'EU App Config',
        },
        {
            key: 'EuConfigComponent',
            component: EuConfigComponent,
            selector: 'eu-config-component',
            type: 'PageComponent',
            label: 'EU Config Component',
        },
        {
            key: 'EuConfigPageWebappComponent',
            component: EuConfigPageWebappComponent,
            selector: 'eu-config-webapp',
            type: 'PageComponent',
            label: 'EU Config Page Webapp',
        },
        {
            key: 'EuOverviewPage',
            component: EuOverviewPage,
            selector: 'mvs-eu-app-config',
            type: 'PageComponent',
            label: 'EU Overview Page',
        },
        {
            key: 'EuRegistrationOverviewPage',
            component: EuRegistrationOverviewPage,
            selector: 'mvs-eu-registration-overview-page',
            type: 'PageComponent',
            label: 'EU Registration Overview Page',
        }
    ]
}

export const EU_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: euModuleEntry, multi: true },
];